import React, { Fragment, useEffect, useContext } from "react";
import { TextsContext } from "context/textsContext";
import styleForm from '../../../scss/form.module.scss';
import ValidaComponent, { APPLICATION } from "../../../components/ValidaComponent";
import Stylegeneral from '../../../scss/general.module.scss'
import { SelectAppComponent } from "components/application/SelectAppComponent";
import { InputTextComponent } from "components/application/InputTextComponent";
import { useLocation } from "react-router-dom";
import { CheckboxComponent } from "components/CheckboxComponent";

const Registro13Page = () => {
    const { texts, verifyCurrentLanguage } = useContext(TextsContext);
    const {pathname} = useLocation();

    useEffect(() => {
		verifyCurrentLanguage();
	}, []);

    return (
        <Fragment>
            <section>
                <div className="container py-3">
                    <div className={`${styleForm.btn_activar}`}>
                        <label htmlFor="examanes" className={`${styleForm.labels} ${styleForm.sin_tootip} raleway  mb-2 color_primary_2 fw_700`}>
                            {texts?.page_thirteen_checkbox_one ?? '¿Alguno de los solicitantes se le ha indicado o se encuentra bajo tratamiento con algún medicamento?'}
                        </label>
                        <div className={`form-check form-switch input-personalizado ${styleForm.col_input}`}>
                            <CheckboxComponent className="form-check-input" type="checkbox" id="examanes" name={"haveMedicaments"} section={"/coberturaprevia"} />
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container pb-5">
                    <div className="row gy-4">
                        <div className={`col-12 ${Stylegeneral.colform}`}>
                            <SelectAppComponent
                                name="solicitante"
                                label={texts?.general_form_field_applicant ?? "Solicitante"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                placeholder='Ej:Colombia'
                                type='text'
                                required
                                options={[]}
                            />

                            <ValidaComponent phase={APPLICATION} section={pathname} keyName={"solicitante"} />
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="namemedicamento"
                                label={texts?.page_thirteen_form_field_medicine ?? "Nombre del medicamento"}
                                placeholder={texts?.page_thirteen_form_placeholder_medicine ?? "Ej: Dolex"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='text'
                            />
                            <ValidaComponent keyName={"namemedicament"} phase={APPLICATION} section={pathname} />
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="dosis"
                                label={texts?.page_thirteen_form_field_dose ?? "Dosis"}
                                placeholder={texts?.page_thirteen_form_placeholder_dose ?? "Ej: 6 cm"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='text'
                            />
                            <ValidaComponent keyName={"dosis"} phase={APPLICATION} section={pathname} />
                        </div>

                        <div className={`col-12 ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="frecuencia"
                                label={texts?.page_thirteen_form_field_frequency ?? "Frecuencia"}
                                placeholder={texts?.page_thirteen_form_placeholder_frequency ?? "Ej: 12 horas"}
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='text'
                            />
                            <ValidaComponent keyName={"frecuencia"} phase={APPLICATION} section={pathname} />
                        </div>

                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="fecha"
                                label={texts?.general_form_field_from ?? "Desde"}
                                placeholder='Ej: Cabeza'
                                tooltip="Geographic area where the policy´s benefits apply"
                                required
                                type='date'
                            />
                            <ValidaComponent keyName={"fecha"} phase={APPLICATION} section={pathname} />
                        </div>

                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.btn_activar}`}>
                                <label htmlFor="infosolicitud" className={`${styleForm.labels} ${styleForm.sin_tootip} raleway  mb-2 color_primary_2 fw_700`}>
                                    {texts?.general_checkbox_medical_condition ?? '¿El solicitante padece actualmente de esta condición médica?'}
                                </label>
                                <div className={`form-check form-switch input-personalizado ${styleForm.col_input}`}>
                                    <CheckboxComponent section={pathname} className="form-check-input" type="checkbox" id="infosolicitud" name={"addDependant"} />
                                </div>
                            </div>
                        </div>
                        <div className={`col-12  ${Stylegeneral.colform}`}>
                            <InputTextComponent
                                section={pathname}
                                name="fechahasta"
                                label={texts?.general_form_field_to ?? "Hasta"}
                                placeholder='Ej: Cabeza'
                                tooltip="Geographic area where the policy´s benefits apply"
                                type='date'
                                required
                            />
                            <ValidaComponent keyName={"fechahasta"} phase={APPLICATION} section={pathname} />
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}
export default Registro13Page;